import { useState } from 'react'
import { motion } from 'framer-motion'
import { ChartNoAxesCombined } from 'lucide-react'

import BasePage from '../basePage'

import { Filter } from './Filter'
import { NetPromote } from './NetPromote'
import { Stars } from './Stars'
import { Comments } from './Comments'
import { CancelamentoAssinatura } from './CancelamentoAssinatura'

import { Container } from './styles'

import { AssessmentsProvider } from '../../hooks/AssessmentsContext'
import { CommentsProvider } from '../../hooks/CommentsContext'
import { PageTabs } from '../../components/ui/PageTabs'
import { useMenu } from '../../store/global/useMenu'

const ABAS = [
  { value: 'nps', label: 'NPS' },
  { value: 'cancelamento', label: 'Cancelamento de assinatura' },
]

export function Avaliacoes() {
  const menuSize = useMenu((st) => st.data.size)

  // A barra de abas padrao do sistema e controlada; a antiga guardava o estado
  // numa store propria e desenhava abas em caixa, fora do padrao das demais
  // telas.
  const [aba, setAba] = useState('nps')

  return (
    <BasePage pageTitle={<><ChartNoAxesCombined className="w-7 h-7" />Avaliações</>}>
      <AssessmentsProvider>
        <motion.div
          initial={{ width: `calc(100vw - 2rem - ${menuSize})` }}
          animate={{ width: `calc(100vw - 2rem - ${menuSize})` }}
          transition={{ duration: 0.3 }}
          className="flex flex-col pt-1.5 pr-4"
        >
          <PageTabs tabs={ABAS} value={aba} onChange={setAba} />

          {aba === 'nps' && (
            <Container container spacing={3}>
              <Filter />
              <NetPromote />
              <Stars />
              <CommentsProvider>
                <Comments />
              </CommentsProvider>
            </Container>
          )}

          {aba === 'cancelamento' && <CancelamentoAssinatura />}
        </motion.div>
      </AssessmentsProvider>
    </BasePage>
  )
}
